import Vue from "vue";
import App from "./app.vue";
import router from "@/router";
import store from "@/store";
import Notifications from "vue-notification";
import QModal from "@/common/plugins/modal";
import Loading from "vue-loading-overlay";
import { abilitiesPlugin } from "@casl/vue";
import ability from "@/services/ability";
import trans18next from "@/i18n";
import VueCookies from "vue-cookies";

// fix on IE11 method fetch and scrollTo
import "whatwg-fetch";
import "element-scroll-polyfill";

Vue.use(Notifications);
Vue.use(QModal);
Vue.use(Loading);
Vue.use(VueCookies);
Vue.use(abilitiesPlugin, ability(), {
  useGlobalProperties: true,
});
Vue.prototype.isLoading = false;
Vue.config.productionTip = false;

if (
  process.env.NODE_ENV === "production" &&
  process.env.VUE_APP_LOG_ROCKET_ID
) {
  (window as any).LogRocket &&
    (window as any).LogRocket.init(process.env.VUE_APP_LOG_ROCKET_ID);
}

const vueApp = new Vue({
  router,
  i18n: trans18next,
  store,
  render: (h) => h(App),
}).$mount("#app");

export default vueApp;
